const APP_URL = process.env.VUE_APP_APP_URL
const API_URL = process.env.VUE_APP_API_URL
const ACCOUNTS_UI_URL = process.env.VUE_APP_ACCOUNTS_UI_URL
const ACCOUNTS_UI_PROFILE = ACCOUNTS_UI_URL
const ACCOUNTS_UI_ADDRESSES = ACCOUNTS_UI_URL + "addresses"
const ACCOUNTS_API_URL = process.env.VUE_APP_ACCOUNTS_API_URL
const LOGIN_URL = ACCOUNTS_UI_URL + "?continue=" + APP_URL
const LOGOUT_URL = ACCOUNTS_UI_URL + "logout?continue=" + APP_URL
const REGISTER_URL = ACCOUNTS_UI_URL + "signup-start?continue=" + APP_URL
const PJILI_PLUS_UI_URL = process.env.VUE_APP_PJILI_PLUS_UI_URL;

export default {
  APP_URL,
  API_URL,
  ACCOUNTS_UI_URL,
  ACCOUNTS_UI_PROFILE,
  ACCOUNTS_UI_ADDRESSES,
  PJILI_PLUS_UI_URL,
  ACCOUNTS_API_URL,
  LOGIN_URL,
  LOGOUT_URL,
  REGISTER_URL
}